/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';


export const defaultNavigation: FuseNavigationItem[] = [
	{
		id: 'divider1',
		type: 'divider',
	},
	// Visão geral fica fora das etapas: é por onde todo mundo entra.
	{
		id: 'apps.innovation.dashboard',
		title: 'Dashboard',
		subtitle: 'Resultados e indicadores',
		type: 'basic',
		icon: 'heroicons_outline:chart-pie',
		link: '/apps/innovation/dashboard',
		auth: ['innovation-dashboard'],
		disabled: false,
	},
	// As etapas numeradas contam o fluxo de uma ideia: cadastrar -> acompanhar -> comitê.
	{
		id: 'flow.participate',
		title: '1. Participe',
		type: 'group',
		children: [
			{
				id: 'apps.innovation.new',
				title: 'Novo projeto',
				subtitle: 'Cadastre sua ideia',
				type: 'basic',
				icon: 'heroicons_outline:plus',
				link: '/apps/innovation/new',
				auth: ['novo-projeto'],
				disabled: false,
			},
			{
				id: 'apps.innovation.new-public',
				title: 'Novo projeto (público)',
				subtitle: 'Cadastro sem login (totem)',
				type: 'basic',
				icon: 'heroicons_outline:globe',
				link: '/apps/innovation/new-public',
				auth: ['totem'],
				disabled: false,
			},
		],
	},
	{
		id: 'flow.follow',
		title: '2. Acompanhe',
		type: 'group',
		children: [
			{
				id: 'tasks',
				title: 'Atividades',
				subtitle: 'Tarefas que aguardam você',
				type: 'basic',
				icon: 'heroicons_outline:check-circle',
				link: '/apps/tasks',
				auth: ['atividades'],
				disabled: false,
			},
			{
				id: 'apps.innovation.search',
				title: 'Inovações',
				subtitle: 'Todas as iniciativas e status',
				type: 'basic',
				icon: 'heroicons_outline:search',
				link: '/apps/innovation/search',
				auth: ['buscar'],
			},
		],
	},
	// Preenchido em runtime pelo NavigationService (unidades do time de performance).
	// Sem unidades, o grupo some junto com o cabeçalho.
	{
		id: 'flow.committee',
		title: '3. Comitê',
		type: 'group',
		children: [],
	},
	{
		id: 'help',
		title: 'Ajuda',
		type: 'group',
		children: [
			{
				id: 'apps.user-manual',
				title: 'Manual do Usuário',
				subtitle: 'Como usar o Inova',
				type: 'basic',
				icon: 'heroicons_outline:book-open',
				link: '/apps/user-manual',
				auth: ['manual-usuario'],
				disabled: false,
			},
			{
				// Sem auth: todo usuário logado vê as notas de versão e abre solicitações.
				id: 'apps.atualizacoes',
				title: 'Atualizações',
				subtitle: 'Notas de versão e solicitações',
				type: 'basic',
				icon: 'heroicons_outline:sparkles',
				link: '/apps/atualizacoes',
			},
		],
	},
	{
		id: 'admin',
		title: 'Administração',
		type: 'group',
		children: [
			{
				id: 'apps.innovation.settings',
				title: 'Configurações',
				type: 'basic',
				icon: 'heroicons_outline:adjustments',
				link: '/apps/innovation/settings/areas',
				auth: ['configuracoes', 'gestao'],
				disabled: false,
			},
			{
				id: 'pages.user-management',
				title: 'Gerenciar Usuários',
				type: 'basic',
				icon: 'heroicons_outline:cog',
				link: '/pages/user-management',
				auth: ['gerenciar-usuarios'],
				disabled: false,
			},
			{
				id: 'pages.user-activity',
				title: 'Atividade de Usuários',
				type: 'basic',
				icon: 'heroicons_outline:users',
				link: '/pages/user-activity',
				auth: ['atividade-usuarios'],
				disabled: false,
			},
		],
	},
];

export const compactNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		tooltip: 'Dashboards',
		type: 'aside',
		icon: 'heroicons_outline:home',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'Apps',
		tooltip: 'Apps',
		type: 'aside',
		icon: 'heroicons_outline:qrcode',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'pages',
		title: 'Pages',
		tooltip: 'Pages',
		type: 'aside',
		icon: 'heroicons_outline:document-duplicate',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'UI',
		tooltip: 'UI',
		type: 'aside',
		icon: 'heroicons_outline:collection',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Navigation',
		tooltip: 'Navigation',
		type: 'aside',
		icon: 'heroicons_outline:menu',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	}
];
export const futuristicNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'DASHBOARDS',
		type: 'group',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'APPS',
		type: 'group',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'others',
		title: 'OTHERS',
		type: 'group'
	},
	{
		id: 'pages',
		title: 'Pages',
		type: 'aside',
		icon: 'heroicons_outline:document-duplicate',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'User Interface',
		type: 'aside',
		icon: 'heroicons_outline:collection',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Navigation Features',
		type: 'aside',
		icon: 'heroicons_outline:menu',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	}
];
export const horizontalNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		type: 'group',
		icon: 'heroicons_outline:home',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'Apps',
		type: 'group',
		icon: 'heroicons_outline:qrcode',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'pages',
		title: 'Pages',
		type: 'group',
		icon: 'heroicons_outline:document-duplicate',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'UI',
		type: 'group',
		icon: 'heroicons_outline:collection',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Misc',
		type: 'group',
		icon: 'heroicons_outline:menu',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	}
];
